






















































import {Component, Inject, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {format} from "date-fns";
import Game, {GameRef} from "@/model/Game";
import TimeUtils from "@/services/TimeUtils";
import {DataService} from "@/services/DataService";
import {PlayerRef} from "@/model/Player";
import {MatchmakingService} from "@/services/MatchmakingService";
import {orderBy} from "lodash";

class TopPlayer {

  public ref!: PlayerRef;
  public participation!: number;
  public mean!: number;
  constructor(playerRef: PlayerRef, mean: number) {
    this.ref = playerRef;
    this.mean = mean;
    this.participation = 1;
  }
}

@Component({
  computed: {
    ...mapGetters({
      games: "games"
    })
  }
})
export default class Games extends Vue {
  @Inject("dataService") public dataService!: DataService;
  @Inject("matchMakingService") public matchMakingService!: MatchmakingService;

  protected games!: Game[];
  private seasonKey: string = "s20";

  get topSeasonPlayers(): TopPlayer[] {
    const players: TopPlayer[] = [];
    const _players: string[] = [];
    this.games.forEach((g) => {
      g.players.forEach((p) => {
        if (_players.indexOf(p.playerRef.guid) === -1) {
          _players.push(p.playerRef.guid);
          players.push(new TopPlayer(p.playerRef, Math.round(this.matchMakingService.computeEMP(p.playerRef.guid, this.games))));
        } else if (_players.indexOf(p.playerRef.guid) >= 0) {
          const _p = players.filter((_p) => _p.ref.guid === p.playerRef.guid)[0];
          _p.participation++;
        }
      });
    });
    return orderBy(players.filter((p) => p.participation > 5), ["mean"], ["desc"]).slice(0, 5);
  }

  get topRecentPlayers(): TopPlayer[] {
    const players: TopPlayer[] = [];
    const _players: string[] = [];
    const games = this.games.slice(0, 5);
    games.forEach((g) => {
      g.players.forEach((p) => {
        if (_players.indexOf(p.playerRef.guid) === -1) {
          _players.push(p.playerRef.guid);
          players.push(new TopPlayer(p.playerRef, Math.round(this.matchMakingService.computeEMP(p.playerRef.guid, games))));
        } else if (_players.indexOf(p.playerRef.guid) >= 0) {
          const _p = players.filter((_p) => _p.ref.guid === p.playerRef.guid)[0];
          _p.participation++;
        }
      });
    });
    return orderBy(players.filter((p) => p.participation >= 2), ["mean"], ["desc"]).slice(0, 5);
  }

  public team1Round1(gameRef: GameRef): number {
    return gameRef.alliesScore;
  }

  public team2Round1(gameRef: GameRef): number {
    return gameRef.axisScore;
  }

  public team1Round2(gameRef: GameRef): number {
    return gameRef.switchGameRef ? gameRef.alliesScore : gameRef.axisScore;
  }

  public team2Round2(gameRef: GameRef): number {
    return gameRef.switchGameRef ? gameRef.axisScore : gameRef.alliesScore;
  }

  public duration(game: Game) {
    if (game.gameRefs[0].startTime) {
      const duration = (game.gameRefs[0].endTime - game.gameRefs[0].startTime) + (game.gameRefs[1].endTime - game.gameRefs[1].startTime);
      return TimeUtils.getReadableDiffTime(duration);
    }
    return null;
  }

  public async goToSeason(season: string) {
    if (this.seasonKey != season) {
      this.seasonKey = season;
      const games = await this.dataService.retrieveGames(this.seasonKey);
      this.$store.commit("gamesRetrieved", games);
    }
  }

  public isEfayaMod(game: Game) {
    return game.mod.startsWith("efaya_mod");
  }

  public isEfayaModV2(game: Game) {
    return game.mod.startsWith("efaya_v2");
  }

  public isIMMMod(game: Game) {
    return game.mod.startsWith("imm");
  }

  public isWW2Mod(game: Game) {
    return game.mod.startsWith("ww2");
  }

  public isPromod(game: Game) {
    return game.mod.startsWith("pml");
  }

  public formatDate(date: Date): string {
    return !isNaN(date.getTime()) ? format(date, "dd/MM/yyyy") : "";
  }

  public goToGame(game: Game) {
    this.$router.push("/game/" + game.map);
  }

  public mapNamer(mapName: string): string {
    return mapName.replace("mp_", "").replace(/_/g, " ").toUpperCase();
  }
}
